import { SearchDocumentTemplateHistory } from './SearchDocumentTemplateHistory.component'

import { withCompose } from '../SearchDocumentHistory.container'

export default withCompose(SearchDocumentTemplateHistory)
